module.exports = __webpack_public_path__ + "mo/img/piece-10.88ca9cec.svg";